import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {campaignIntegrationsInitialState} from './campaignIntegrations.config';
import {CampaignIntegration} from 'common/src/modules/campaignIntegrations/campaignIntegrations.types';

const campaignIntegrationsSlice = createSlice({
  name: 'campaignIntegrationsSlice',
  initialState: campaignIntegrationsInitialState,
  reducers: {
    resetCampaignIntegrationsState: () => campaignIntegrationsInitialState,
    updateConnectedCampaigns: (state, action: PayloadAction<CampaignIntegration[]>) => {
      state.connectedCampaigns = action.payload;
    },
    updateIntegratedServices: (state, action: PayloadAction<CampaignIntegration[]>) => {
      state.integratedServices = action.payload;
    },
    updateAreIntegrationsLoading: (state, action: PayloadAction<boolean>) => {
      state.areIntegrationsLoading = action.payload;
    },
  },
});

const {
  resetCampaignIntegrationsState,
  updateAreIntegrationsLoading,
  updateConnectedCampaigns,
  updateIntegratedServices,
} = campaignIntegrationsSlice.actions;
export {
  resetCampaignIntegrationsState,
  updateAreIntegrationsLoading,
  updateConnectedCampaigns,
  updateIntegratedServices,
};

export default campaignIntegrationsSlice.reducer;
